import { hc } from "hono/client";
import type { AppType } from "@/server/index";

/**
 * Type-safe API client.
 * Every route defined in the Hono server is available here with full type inference.
 * If the server changes a return type, this client will show compile errors.
 */
export const api = hc<AppType>("/");
